import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import AppShell from "./components/AppShell";
import Dashboard from "./pages/Dashboard";
import SketchStudio from "./pages/SketchStudio";
import MaterialStudio from "./pages/MaterialStudio";
import BulkStudio from "./pages/BulkStudio";
import TryOnStudio from "./pages/TryOnStudio";
import Library from "./pages/Library";
import DesignsGallery from "./pages/DesignsGallery";
import DesignDetail from "./pages/DesignDetail";
import Collections from "./pages/Collections";
import CollectionDetail from "./pages/CollectionDetail";
import StylesPage from "./pages/StylesPage";
import TeamPage from "./pages/TeamPage";
import TechpacksGallery from "./pages/TechpacksGallery";
import TechpackDetail from "./pages/TechpackDetail";
import CostingGallery from "./pages/CostingGallery";
import CostSheetDetail from "./pages/CostSheetDetail";
import POsGallery from "./pages/POsGallery";
import PurchaseOrderDetail from "./pages/PurchaseOrderDetail";
import CollectionPlanning from "./pages/CollectionPlanning";
import LinePlanning from "./pages/LinePlanning";
import TACalendar from "./pages/TACalendar";
import ComponentLibrary from "./pages/ComponentLibrary";
import MaterialManagement from "./pages/MaterialManagement";
import ColourManagement from "./pages/ColourManagement";
import SupplierManagement from "./pages/SupplierManagement";
import RFQManagement from "./pages/RFQManagement";
import SampleManagement from "./pages/SampleManagement";
import QualityTesting from "./pages/QualityTesting";
import Compliance from "./pages/Compliance";
import SKUManagement from "./pages/SKUManagement";
import DAM from "./pages/DAM";
import Reports from "./pages/Reports";
import WorkflowEngine from "./pages/WorkflowEngine";
import Integration from "./pages/Integration";
import AIGovernance from "./pages/AIGovernance";
import AICostIntelligence from "./pages/AICostIntelligence";
import ArtworkManagement from "./pages/ArtworkManagement";
import SizeChartManagement from "./pages/SizeChartManagement";
import PatternEngineering from "./pages/PatternEngineering";
import SupplierEvaluation from "./pages/SupplierEvaluation";
import DesignStudio from "./pages/DesignStudio";
import Notifications from "./pages/Notifications";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-6 h-6 border-2 border-black border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/studio/sketch" element={<SketchStudio />} />
              <Route path="/studio/materials" element={<MaterialStudio />} />
              <Route path="/studio/bulk" element={<BulkStudio />} />
              <Route path="/studio/tryon" element={<TryOnStudio />} />
              <Route path="/studio/design" element={<DesignStudio />} />
              <Route path="/studio/design/:id" element={<DesignStudio />} />
              <Route path="/library" element={<Library />} />
              <Route path="/designs" element={<DesignsGallery />} />
              <Route path="/designs/:id" element={<DesignDetail />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/:id" element={<CollectionDetail />} />
              <Route path="/techpacks" element={<TechpacksGallery />} />
              <Route path="/techpacks/:id" element={<TechpackDetail />} />
              <Route path="/costing" element={<CostingGallery />} />
              <Route path="/costing/:id" element={<CostSheetDetail />} />
              <Route path="/purchase-orders" element={<POsGallery />} />
              <Route path="/purchase-orders/:id" element={<PurchaseOrderDetail />} />
              <Route path="/styles" element={<StylesPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/plm/collection-planning" element={<CollectionPlanning />} />
              <Route path="/plm/line-planning" element={<LinePlanning />} />
              <Route path="/plm/ta-calendar" element={<TACalendar />} />
              <Route path="/plm/components" element={<ComponentLibrary />} />
              <Route path="/plm/materials" element={<MaterialManagement />} />
              <Route path="/plm/colours" element={<ColourManagement />} />
              <Route path="/plm/suppliers" element={<SupplierManagement />} />
              <Route path="/plm/supplier-evaluation" element={<SupplierEvaluation />} />
              <Route path="/plm/rfqs" element={<RFQManagement />} />
              <Route path="/plm/artworks" element={<ArtworkManagement />} />
              <Route path="/plm/size-charts" element={<SizeChartManagement />} />
              <Route path="/plm/pattern-engineering" element={<PatternEngineering />} />
              <Route path="/plm/samples" element={<SampleManagement />} />
              <Route path="/plm/quality" element={<QualityTesting />} />
              <Route path="/plm/compliance" element={<Compliance />} />
              <Route path="/plm/skus" element={<SKUManagement />} />
              <Route path="/plm/assets" element={<DAM />} />
              <Route path="/plm/reports" element={<Reports />} />
              <Route path="/plm/workflows" element={<WorkflowEngine />} />
              <Route path="/integrations" element={<Integration />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/ai-governance" element={<AIGovernance />} />
              <Route path="/plm/cost-intelligence" element={<AICostIntelligence />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
